






































































































































import _ from "lodash";
import rest from "@/rest";
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { Action, namespace } from "vuex-class";
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
// component
import AnimatedButton from "../Shared/AnimatedButton.vue";
// interfaces
const globals = namespace("globals");
const ux = namespace("ux");

@Component({
  components: {
    AnimatedButton
  },
})
export default class TopicSheet extends Vue {
  @Prop() title!: string;
  @Prop() text!: string;
  @Prop() imgSrc!: string;
  @Prop() altText!: string;
  // @Prop() noImage!: boolean;
  @Prop() size!: string; // 24, evtl.: x-small, small, medium, large, x-large
  @Prop() color!: string;
  @Prop() weight!: string; // lighter, normal, bold, bolder, 100,200,300,400,500,600,700,800,900
  @Prop() fontStyle!: string; // normal, italic, oblique

  @ux.State darkTheme: any;
  @ux.Getter gradientBackground: any;
  @ux.Getter gradientBackground2: any;
  @ux.Getter gradientBackground3: any;
  @ux.Getter gradientText: any;

  showDialog: boolean = false;

  // $refs!: {};

  mounted() {}

  @Watch("showDialog")
  async onShowDialogChanged(val: boolean) {
    if (this.showDialog) {
      // On dialog open

      // Disable body scroll on iOS
      this.$nextTick(async () => {
        await this.$globalHelper.delay(10);
        const modal = document.querySelector('.modal');
        disableBodyScroll(modal);
      });
    } else {
      // Dialog closing
      clearAllBodyScrollLocks();
    }
  }

  beforeDestroy() {
    clearAllBodyScrollLocks();
  }

  onCancel() {
    clearAllBodyScrollLocks();
    this.showDialog = false;
  }

  get headLineStyle() {
    let lineStyle = "";
    if (this.$vuetify.breakpoint.xsOnly) lineStyle = "text-h6";
    else lineStyle = "text-h5";

    // if (this.darkTheme)
    //   lineStyle += " gradientDarkText";
    // else
    //   lineStyle += " gradientLightText";

    return lineStyle;
  }

  get fontSize() {
    if (this.size == null) return "18px";
    if (isNaN(Number(this.size)))
      // Number(this.size) != NaN)
      return this.size;
    return this.size + "px";
  }

  get lineHeight() {
    let fs = this.fontSize.replace("px", "");
    if (isNaN(Number(fs))) return this.fontSize;

    return Number(fs) + 2 + "px";
  }
}
